
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"33","height":"25","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M27.637 20.78c-.01-.124-.023-.217-.026-.312-.029-.996-.027-.996.942-1.07 1.128-.087 2.137-1.086 2.14-2.217.017-4.505.017-9.01.002-13.513-.005-1.136-1.002-2.13-2.136-2.22-.209-.015-.418-.011-.627-.011-7.89 0-15.778.03-23.667-.023C2.36 1.4 1.408 2.752 1.43 4.278c.062 4.162.02 8.325.022 12.487 0 1.61.949 2.62 2.555 2.629.687.003.575.414.598.825.024.437-.082.64-.592.639C1.701 20.855.011 19.213.005 16.89 0 12.576-.002 8.26.006 3.947.011 1.647 1.67.002 3.961 0h24.294c2.252 0 3.886 1.628 3.887 3.87.002 4.37.002 8.742 0 13.114 0 2.45-2.025 4.177-4.505 3.796z","fill":"#fff"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M26.193 14.929c0 2.394.012 4.789-.004 7.183-.01 1.51-1.48 2.39-2.753 1.67-.668-.377-.934-.997-.936-1.715-.013-4.808-.018-9.616 0-14.423.005-1.197.822-1.968 1.931-1.937 1.045.029 1.76.85 1.762 2.039.003 2.394 0 4.789 0 7.183zM15.143 17.098c0 1.708.003 3.417-.002 5.126-.002 1.068-.783 1.867-1.803 1.862-1.034-.005-1.81-.787-1.813-1.86-.007-3.437-.006-6.873 0-10.31.002-1.072.781-1.857 1.81-1.86 1.025-.002 1.803.793 1.806 1.859.005 1.728.002 3.455.002 5.183zM17.003 18.35c0-1.215-.006-2.432.002-3.648.008-1.147.787-1.985 1.832-1.985 1.04 0 1.83.78 1.841 1.917.025 2.508.022 5.017.002 7.526-.01 1.127-.803 1.922-1.831 1.923-1.06 0-1.834-.815-1.843-1.97-.01-1.253-.003-2.508-.003-3.762zM9.66 20.267c0 .645.007 1.29-.002 1.936-.013 1.049-.74 1.824-1.747 1.876-.952.05-1.806-.602-1.857-1.606a44.356 44.356 0 01.007-4.543c.05-.958.92-1.591 1.857-1.536.972.057 1.71.795 1.737 1.766.02.701.004 1.405.004 2.107z","fill":"#fff"}})])
          )
        }
      }
    